import { PriceItxDto } from "src/api/customer";
import { CurrencyLocale } from "src/hooks/Utils/Shop/useCurrencyLocale";
import { renderPrice } from "./Prices";
export const PRICE_TYPE = {
    DECIMAL_TO_INTEGER: "DECIMAL_TO_INTEGER",
    INTEGER_TO_DECIMAL: "INTEGER_TO_DECIMAL"
  } as const;
  
  export type PriceType =
    (typeof PRICE_TYPE)[keyof typeof PRICE_TYPE];
  interface PriceTo {
    type: PriceType;
    inputPrice?: string;
    price?: any;
    currencyLocale?: CurrencyLocale;
    withoutCurrency?: boolean;
    roundUp?: boolean
  }
  
  const cleanDecimals = (decimals: string): string => {
    return decimals.replace(/[.,\s]/g, '');
  }
  
  const fillZeros = (inputPrice: string, differenceCount: number): string => {
    if (differenceCount > 0) {
        return inputPrice + '0'.repeat(differenceCount);
    }
    return inputPrice;
  };
  
  const changeDecimalsToInteger = (input: string, currencyLocale: CurrencyLocale): string => {
    const { currencyDecimals, currencySeparators } = currencyLocale;
    const { decimalSeparator } = currencySeparators;
  
    let decimalCount = 0;
    const decimalPart = input?.split(decimalSeparator)[1];
    decimalCount = decimalPart ? decimalPart.length : 0;
  
    if (decimalCount < currencyDecimals) {
      const countDecimals = currencyDecimals - decimalCount;
      const result = fillZeros(input, countDecimals);
      return cleanDecimals(result);
    }
    return cleanDecimals(input);
  }
  
  const parsePriceTo = ({type, inputPrice, price, currencyLocale, withoutCurrency, roundUp}: PriceTo) => {
    if (type === PRICE_TYPE.DECIMAL_TO_INTEGER) {
      return changeDecimalsToInteger(inputPrice, currencyLocale);
    }
    if (type === PRICE_TYPE.INTEGER_TO_DECIMAL) {
      return renderPrice(price, withoutCurrency, roundUp);
    }
    return null;
  }

  export const IsEqualToPriceDTO = (value: string, price: PriceItxDto, currencyLocale: CurrencyLocale): boolean => {
    return getPriceWithDecimals(value, currencyLocale) == price.value;
  }

  export const IsHigherToPriceDTO = (value: string, price: PriceItxDto, currencyLocale: CurrencyLocale): boolean => {
    return getPriceWithDecimals(value, currencyLocale) > price.value;
  }
  
  export const getPriceWithDecimals = (value: string, currencyLocale: CurrencyLocale) : number => {
    const { currencyDecimals, currencySeparators } = currencyLocale;
    const { decimalSeparator } = currencySeparators;
    
    const hasDecimalSeparator = value?.includes(decimalSeparator);
   
    if (hasDecimalSeparator) {
      const type = PRICE_TYPE.DECIMAL_TO_INTEGER;
      return Number(parsePriceTo({type, inputPrice: value, currencyLocale}))
    }
    return Number(fillZeros(value, currencyDecimals)) 
  }
  
  export const getPriceFormatItxDto = (price: string, currencyLocale: CurrencyLocale): PriceItxDto => {
    const { currencyCode, currencyDecimals } = currencyLocale;
    const priceToInteger = parsePriceTo({type: PRICE_TYPE.DECIMAL_TO_INTEGER, inputPrice: price, currencyLocale});

    return {
      currency: currencyCode,
      value: Number(priceToInteger),
      exponent: currencyDecimals,
    }
  }